module.exports = __webpack_public_path__ + "img/1480362942.34714847.jpg";